export default __webpack_public_path__ + "static/media/cardboard-removal.7e704a2e.svg";